import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import classNames from 'classnames';

const useStyles = makeStyles(
  {
    input: {}
  },
  {
    name: "CatalogReactEntityAutocompletePickerInput"
  }
);
function EntityAutocompletePickerInput(params) {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(
    TextField,
    {
      variant: "outlined",
      ...params,
      className: classNames(classes.input, params.className)
    }
  );
}

export { EntityAutocompletePickerInput };
//# sourceMappingURL=EntityAutocompletePickerInput.esm.js.map
